import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchDataAndUpdateStore,
  fetchSelectedListAndAppendToModule,
} from '../../../redux/actions';
import { getGridDataByModuleKey } from '../../../redux/selector';
import SelectionRemoveModal from '../../../shared/component/SelectionRemoveModal';

const GlobalSearch = ({ moduleName, fullSelection }) => {
  const dispatch = useDispatch();
  const gridData = useSelector(getGridDataByModuleKey(moduleName));
  const [searchValue, setSearchValue] = useState(gridData?.inputPayload?.searchText || '');
  const [show, setShow] = useState(false);

  useEffect(() => {
    setSearchValue(gridData?.inputPayload?.searchText || '');
  }, [gridData?.inputPayload?.searchText]);

  const handleClose = () => {
    setShow(false);
  };

  const handleConfirm = () => {
    onSearch();
    setShow(false);
  };

  const openModal = () => {
    if (fullSelection && fullSelection.length > 0) {
      setShow(true);
    } else {
      onSearch();
    }
  };

  const onSearch = () => {
    const searchText = searchValue.trim();

    if (searchText) {
      const payload = {
        ...gridData?.inputPayload,
        pageNumber: 1, // Reset to first page on filter change
        searchText: searchText,
      };

      console.log('Filter Payload:', payload);

      dispatch(
        fetchDataAndUpdateStore({
          key: moduleName,
          inputData: payload,
        })
      );
      dispatch(
        fetchSelectedListAndAppendToModule({
          key: moduleName,
          selectedList: null,
        })
      );
    } else {
      clearSearch(); // Call clearSearch when input is empty
    }
  };

  const clearSearch = () => {
    setSearchValue('');
    const payload = gridData?.inputPayload;
    const updatedPayload = { ...payload, searchText: '' };

    // Dispatch if payload has changed
    if (JSON.stringify(payload) !== JSON.stringify(updatedPayload)) {
      dispatch(
        fetchDataAndUpdateStore({
          key: moduleName,
          inputData: updatedPayload,
        })
      );
    }

    // Always dispatch selected list reset
    dispatch(
      fetchSelectedListAndAppendToModule({
        key: moduleName,
        selectedList: null,
      })
    );
  };

  const [isFocused, setIsFocused] = useState(false);
  return (
    <>
      <div className="heading_item" id="contct_search">
        <div className="search-container">
          <input
            className={`form-control${searchValue ? ' focused' : ''}`}
            id="filter-text-box"
            type="text"
            placeholder="Search..."
            onChange={(e) => setSearchValue(e.target.value)}
            value={searchValue}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                openModal();
              }
            }}
          />
          {searchValue && (
            <span className="clear-btn" onClick={clearSearch}>
              &times;
            </span>
          )}
          <button
            className="contactsearch"
            type="button"
            onClick={openModal}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
          </button>
        </div>
      </div>
      {show && (
        <SelectionRemoveModal
          show={show}
          handleClose={handleClose}
          handleConfirm={handleConfirm}
          text={'All selection will be lost, Want to Proceed?'}
        />
      )}
    </>
  );
};

export default GlobalSearch;
